import { put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../../home/selectors'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'
import { setExamPNNVValue, setExamValue } from '../store/bodySurvey.actions'
import { IBodySurveyOptions } from '../../../../options/store/options.types'
import { getBodySurveyOptionsSelector } from '../../../../options/selectors'
import { BodySurveyConstants } from '../store/bodySurvey.constants'
import { setLocationNames } from '../../../../../utilities/bodySurvey.util'
import { IBodySurveyState } from '../store/bodySurvey.types'
import { getBodySurveySelector } from '../selectors'

export function* setDefaults() {
  const pcrID: string = yield select(getPcrIdSelector)
  const bodySurvey: IBodySurveyState = yield select(getBodySurveySelector)
  const { __setDefaults } = bodySurvey

  if (pcrID) {
    try {
      if (!__setDefaults) return
      const examOptions: IBodySurveyOptions = yield select(getBodySurveyOptionsSelector)
      const { assessmentDefaultOptions } = examOptions
      const updatedOptions = setLocationNames(assessmentDefaultOptions)
      yield put(setExamValue(updatedOptions))
      yield put(setExamPNNVValue([]))
    } catch (e) {
      yield put(throwPcrException(`setDefaultsSaga() error: ${e}`))
    }
  }
}

export function* setDefaultsSaga() {
  yield takeLatest([BodySurveyConstants.SET_DEFAULTS], performWithMutexHOG, setDefaults)
}
